import { Component, HostListener, Input, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-text',
  templateUrl: './sample-text.component.html',
  styleUrls: ['./sample-text.component.scss']
})
export class SampleTextComponent implements OnInit {

  @Input() block: any;
  public isLinkEsternal: boolean = false;
  public domainWebsite = environment.urlApi;
  @HostListener('click', ['$event'])
  onClick(event: any) {
    this.helpersService.viewportScroll(event);
  }

  constructor(
    public helpersService: HelpersService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.isLinkEsternal = this.block.link_cta ? this.helpersService.verifyLinkExternal(this.block.link_cta.url) : false;
  }
}
